 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		84: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		84: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"BusinessProtect360.Generate","23":"CILeadForm","24":"CIP.FactFormApp","25":"CIProtect360.Dashboard","26":"CIProtect360.Details","27":"CIProtect360.Direct.Generate","28":"CIProtect360.Generate","29":"CampaignLeadForm","30":"CarProtect360","31":"CashCardShield","32":"ChoicesProtect360","33":"CommissionStatement","34":"Common.Error","35":"Common.MyInfoCallback","36":"ComplimentaryHomeContents","37":"ConsumerPortal","38":"ContactUs","39":"CorporateTravel","40":"Debug","41":"EMAPortal","42":"EarlyProtect360Plus","43":"EarlyProtect360Plus.Dashboard","44":"EarlyProtect360Plus.Details","45":"FamilyProtect360","46":"FilipinoBond","47":"FlashPayShieldWithUpgrade","48":"FraudProtect360","49":"HIProtect360Protect360","50":"HomeProtect360","51":"HomeProtectLite","52":"HomeSafe","53":"HomeStarterKit","54":"InternalDemoCookie","55":"KeymanProtect360","56":"KeymanProtect360.Dashboard","57":"KeymanProtect360.Details","58":"LeadForm","59":"Loan Protect 360 Renewal","60":"LoanProtect360","61":"LoanProtect360.Dashboard","62":"LoanProtect360.Details","63":"MaidProtect360","64":"MotoringCardShieldWithUpgrade","65":"Motorshow2020","66":"PartnerProgram","67":"PhoneProtect360","68":"PowerAgentPortal","69":"Prestige","70":"Prestige.Secured","71":"PublicHousingAssured","72":"ReviewUs","73":"SOA","74":"SingaporeTravelPass","75":"Touristcard","76":"TravelAssured","77":"TravelAssuredPlus","78":"TravelProtect360","79":"TravelProtect360Plus","80":"cileadform","81":"currencyconverter","83":"motorshow","85":"transferprotect360pro","86":"vCashCard","87":"weather"}[chunkId]||chunkId) + "." + {"0":"10af16e4","1":"e7618445","2":"b4227630","3":"4a8417d7","4":"2d37702a","5":"65289bd7","6":"19a4cdee","7":"f7d03ebb","8":"ded8b6e2","9":"ee664845","10":"c12f6bff","11":"4be5edce","12":"84e04226","13":"c2b2a608","14":"8a68e6dd","15":"0429a6e5","16":"4898958c","17":"d5250d89","18":"e790c46e","19":"cc30a307","20":"06b0746b","21":"dbd8ed31","22":"67730eaa","23":"926bf3a9","24":"dedabe5b","25":"ef3e9e08","26":"b6c4cdcd","27":"ecdd3df5","28":"24b0f650","29":"568ea383","30":"5d9b5263","31":"2f56cd39","32":"b8e987a6","33":"7d7b652a","34":"9787590f","35":"dd922f2f","36":"350ed1fa","37":"5b8be323","38":"a4da067a","39":"c11784f6","40":"f309cd1e","41":"68ce8279","42":"340a30bb","43":"cfb88cb0","44":"b4fa5468","45":"90e4f758","46":"60d4e0d0","47":"42a96eca","48":"ce813932","49":"fe07e291","50":"8718a008","51":"c603f610","52":"a9faf616","53":"a02a8e5e","54":"a469d250","55":"a6f48a37","56":"d39826db","57":"dfae4159","58":"d7fdfaa4","59":"ddef09cf","60":"11ec1878","61":"c229d031","62":"88b373f4","63":"bc95cacf","64":"3d8c5ce3","65":"f2b06d0c","66":"58f3f7d2","67":"a98ba7fc","68":"b823ddec","69":"a2f81a74","70":"d2dcc774","71":"cef5cfe6","72":"534a0e7b","73":"6b670b7d","74":"cb88ad42","75":"83c0fb43","76":"f71f0e68","77":"ef4f9d44","78":"9b6d40da","79":"fffc591a","80":"c9314027","81":"cf81ca47","83":"2643b90c","85":"ef5fa87f","86":"7a200bd9","87":"d77cb760","89":"52fcf8c4","90":"c98c9516","91":"df49e9d7","92":"7e7d5e04","93":"1c3e66ef","94":"f464132d","95":"863a3736","96":"9c0c05a2","97":"baf73fc7","98":"1677e1ad","99":"526b2cdd","100":"7eb61b16","101":"70660f06","102":"f9dfbccb","103":"ace3bbfd","104":"067c65fa","105":"2103682c","106":"d9c930ff","107":"4379cd7c","108":"3ce6e2f8","109":"377f65bc","110":"1b7f3191","111":"ab62df75","112":"622c879f","113":"fb071f4b","114":"aa7a522c","115":"810cc520","116":"6c04b1d5","117":"0d8d3756","118":"bd45c582","119":"6574eb65","120":"8abf8821","121":"903a996a","122":"9f4de669","123":"98ca5401","124":"ca9ee762","125":"f4b87895","126":"f1af2070","127":"9cadedd1","128":"463f7f03","129":"2f1013f2","130":"b188b70f","131":"01d7eceb","132":"9c176280","133":"e35d0595","134":"2c90058b","135":"b46f05a3","136":"1e25e150","137":"cdf8d9e2","138":"7f506c36","139":"9f8df9cb","140":"305023fb","141":"31732cc8","142":"ccd12242","143":"30ac5d7d","144":"12bf57d4","145":"c3aa91cc","146":"38d22056","147":"1dcff531","148":"0fc9300a","149":"a92a9f8a","150":"f4aa30e5","151":"93d436f2","152":"e0593dd6","153":"e4223368","154":"2dd3a9fb","155":"70376aac","156":"622eec4a","157":"e6b5a686","158":"5852794c","159":"a0cf3ed0","160":"58b31551","161":"c181e573","162":"45b46424","163":"4f876fa1","164":"0b9bd9fd","165":"29fecf3a","166":"8d4d6f22","167":"8147a043","168":"2ee8862e","169":"cc344cec","170":"397d9aa5"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"19":1,"21":1,"22":1,"24":1,"27":1,"29":1,"30":1,"31":1,"32":1,"33":1,"36":1,"37":1,"39":1,"40":1,"42":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"55":1,"58":1,"63":1,"64":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"83":1,"85":1,"86":1,"87":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"108":1,"109":1,"116":1,"118":1,"121":1,"122":1,"125":1,"126":1,"127":1,"128":1,"129":1,"130":1,"131":1,"132":1,"133":1,"134":1,"135":1,"136":1,"137":1,"138":1,"150":1,"151":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"18":"App2DPaymentComplete","19":"AppPayment","20":"AppPaymentComplete","21":"AppPaymentProcessing","22":"BusinessProtect360.Generate","23":"CILeadForm","24":"CIP.FactFormApp","25":"CIProtect360.Dashboard","26":"CIProtect360.Details","27":"CIProtect360.Direct.Generate","28":"CIProtect360.Generate","29":"CampaignLeadForm","30":"CarProtect360","31":"CashCardShield","32":"ChoicesProtect360","33":"CommissionStatement","34":"Common.Error","35":"Common.MyInfoCallback","36":"ComplimentaryHomeContents","37":"ConsumerPortal","38":"ContactUs","39":"CorporateTravel","40":"Debug","41":"EMAPortal","42":"EarlyProtect360Plus","43":"EarlyProtect360Plus.Dashboard","44":"EarlyProtect360Plus.Details","45":"FamilyProtect360","46":"FilipinoBond","47":"FlashPayShieldWithUpgrade","48":"FraudProtect360","49":"HIProtect360Protect360","50":"HomeProtect360","51":"HomeProtectLite","52":"HomeSafe","53":"HomeStarterKit","54":"InternalDemoCookie","55":"KeymanProtect360","56":"KeymanProtect360.Dashboard","57":"KeymanProtect360.Details","58":"LeadForm","59":"Loan Protect 360 Renewal","60":"LoanProtect360","61":"LoanProtect360.Dashboard","62":"LoanProtect360.Details","63":"MaidProtect360","64":"MotoringCardShieldWithUpgrade","65":"Motorshow2020","66":"PartnerProgram","67":"PhoneProtect360","68":"PowerAgentPortal","69":"Prestige","70":"Prestige.Secured","71":"PublicHousingAssured","72":"ReviewUs","73":"SOA","74":"SingaporeTravelPass","75":"Touristcard","76":"TravelAssured","77":"TravelAssuredPlus","78":"TravelProtect360","79":"TravelProtect360Plus","80":"cileadform","81":"currencyconverter","83":"motorshow","85":"transferprotect360pro","86":"vCashCard","87":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"a858c2f5","20":"31d6cfe0","21":"a858c2f5","22":"d30bc41f","23":"31d6cfe0","24":"d33f62d9","25":"31d6cfe0","26":"31d6cfe0","27":"58058363","28":"31d6cfe0","29":"05f863ac","30":"ddf1f108","31":"04bc7233","32":"ddf1f108","33":"d33f62d9","34":"31d6cfe0","35":"31d6cfe0","36":"0e4fba13","37":"978e5247","38":"31d6cfe0","39":"ac3f861f","40":"5d27deaa","41":"31d6cfe0","42":"58058363","43":"31d6cfe0","44":"31d6cfe0","45":"ddf1f108","46":"ddf1f108","47":"0e4fba13","48":"ddf1f108","49":"ddf1f108","50":"471a3a57","51":"471a3a57","52":"471a3a57","53":"0e4fba13","54":"31d6cfe0","55":"58058363","56":"31d6cfe0","57":"31d6cfe0","58":"dd9a60e3","59":"31d6cfe0","60":"31d6cfe0","61":"31d6cfe0","62":"31d6cfe0","63":"14284125","64":"0e4fba13","65":"31d6cfe0","66":"8b647349","67":"471a3a57","68":"716aad65","69":"2fc531d7","70":"cdec5a50","71":"471a3a57","72":"31d6cfe0","73":"d33f62d9","74":"2e8fdc12","75":"7986da5d","76":"86c9f98d","77":"86c9f98d","78":"2e8fdc12","79":"86c9f98d","80":"22b92479","81":"7b4f34de","83":"49234f01","85":"14284125","86":"94b03ce8","87":"23255cb6","89":"31d6cfe0","90":"cce35a68","91":"440606be","92":"2d576837","93":"de3d9b53","94":"8b4bb37c","95":"f93319e8","96":"72c6f688","97":"f93319e8","98":"f93319e8","99":"72c6f688","100":"72c6f688","101":"de0b9e9d","102":"31d6cfe0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"31d6cfe0","107":"31d6cfe0","108":"6f6df1fe","109":"6f6df1fe","110":"31d6cfe0","111":"31d6cfe0","112":"31d6cfe0","113":"31d6cfe0","114":"31d6cfe0","115":"31d6cfe0","116":"6f6df1fe","117":"31d6cfe0","118":"6f6df1fe","119":"31d6cfe0","120":"31d6cfe0","121":"4b48318c","122":"4b48318c","123":"31d6cfe0","124":"31d6cfe0","125":"4b48318c","126":"4b48318c","127":"4b48318c","128":"4b48318c","129":"4b48318c","130":"4b48318c","131":"4b48318c","132":"4b48318c","133":"4b48318c","134":"4b48318c","135":"4b48318c","136":"4b48318c","137":"4b48318c","138":"4b48318c","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"5fe6802c","151":"5fe6802c","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0","155":"31d6cfe0","156":"31d6cfe0","157":"31d6cfe0","158":"31d6cfe0","159":"31d6cfe0","160":"31d6cfe0","161":"31d6cfe0","162":"31d6cfe0","163":"31d6cfe0","164":"31d6cfe0","165":"31d6cfe0","166":"31d6cfe0","167":"31d6cfe0","168":"31d6cfe0","169":"31d6cfe0","170":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
